import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn.js';

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  invalid?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(function Textarea(
  { invalid, className, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'w-full rounded-lg border px-3 py-2.5 text-[15px] leading-relaxed',
        'bg-white text-ink placeholder:text-muted-soft',
        'border-line hover:border-line-strong',
        'transition-colors duration-150',
        'focus-visible:outline-none focus-visible:border-navy focus-visible:ring-2 focus-visible:ring-navy/20',
        invalid && 'border-danger focus-visible:border-danger focus-visible:ring-danger/20',
        'disabled:bg-cream-deep/40 disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  );
});
